import { render } from "./UiTestReport.vue?vue&type=template&id=52be565a&scoped=true&ts=true"
import script from "./UiTestReport.vue?vue&type=script&lang=ts"
export * from "./UiTestReport.vue?vue&type=script&lang=ts"

import "./UiTestReport.vue?vue&type=style&index=0&id=52be565a&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52be565a"]])

export default __exports__